import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import SignUp from '../../components/pages/SignUp';
import { createNewAccount } from '../../store/actions/signUp';
import { signInFlow } from '../../store/actions/auth';
import token from '../../utils/token';
import Spinner from '../../components/common/Spinner';
import { VALIDATED } from '../../constants/auth';

function SignUpContainer(props) {
  const { signInFlow, currentStep } = props;
  const accessToken = token.getToken();
  const shouldSignIn = accessToken && currentStep === VALIDATED;

  useEffect(() => {
    if (shouldSignIn) {
      signInFlow();
    }
  }, [shouldSignIn, signInFlow]);

  if (shouldSignIn) {
    return <Spinner />;
  }

  return (
    <FullPageLayout>
      <SignUp {...props} />
    </FullPageLayout>
  );
}

const mapStateToProps = (state) => {
  const { signup, auth } = state;

  return {
    error: signup.error,
    currentStep: auth.currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  create: (data) => dispatch(createNewAccount(data)),
  signInFlow: () => dispatch(signInFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpContainer);
